it("should load circular dependencies correctly", function() {
	require("./circular").should.be.eql(1);
});



/*****************
 ** WEBPACK FOOTER
 ** ./runtime/circular-dependencies/index.js
 ** module id = 0
 ** module chunks = 0
 **/